import Chart from 'chart.js/auto';

jQuery(document).ready(function($) {
  (async function() {
    if($('#booking_chart_hold').length) {
      const data = $('#booking_chart_hold').data('chart-details');

      new Chart(
        document.getElementById('booking_chart_hold'),
        {
          type: 'line',
          data: {
            labels: data.map(row => row.day),
            datasets: [
              {
                label: 'Covers by day',
                data: data.map(row => row.covers),
                backgroundColor: '#2bb167',
                borderColor: "#16856e",
              }
            ]
          },
          options: {
            resizeDelay: 30,
            scales: {
              y: {
                ticks: {
                  precision: 0
                }
              }
            }
          }
        }
      );
    }
    

    
  })();
});